<template>
  <div
    :class="[
      'step',
      { 'step--active': selected },
      { 'step--detached': !attached }
    ]"
    @click="$emit('click', path)"
  >
    <div class="step__title">
      {{ step.name }}
    </div>
    <div class="step__type">
      <b-tag type="is-info">{{ type }}</b-tag>
    </div>
    <a
      v-if="attached"
      class="step__action"
      role="button"
      @click.stop="detachStepHandler"
    >
      <b-icon icon="minus-circle" type="is-danger" />
    </a>
    <a
      v-else
      class="step__action"
      role="button"
      @click.stop="attachStepHandler"
    >
      <b-icon icon="plus-circle" type="is-primary" />
    </a>
    <b-icon icon="chevron-right" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    attached: Boolean,
    selected: Boolean,
    step: Object
  },
  computed: {
    type() {
      switch (this.step.collection) {
        case 'videos':
          return 'video';
        case 'tests':
          return 'test';
        default:
          return 'invalid';
      }
    },
    path() {
      return `${this.step.collection}/${this.step.id}`;
    }
  },
  methods: {
    ...mapActions('concepts', ['attachReference', 'detachReference']),
    async attachStepHandler() {
      try {
        await this.attachReference({ path: this.path });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to attach step!',
          type: 'is-danger'
        });
      }
    },
    async detachStepHandler() {
      try {
        await this.detachReference({ path: this.path });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to detach step!',
          type: 'is-danger'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.step {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;

  &:hover {
    background-color: rgba($secondary-color, 0.5);
  }

  &--active {
    background-color: $secondary-color !important;
  }

  &--detached {
    border-bottom: 1px solid $border-color;

    &:first-child {
      border-top: 1px solid $border-color;
    }
  }

  &__action {
    margin-right: 0.5rem;
  }

  &__title {
    flex: 1;
    margin-right: 0.5rem;
    line-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // Needed to make flex children to stick to its flex value in cases when
    // content tries to stretch it beyound its limit
    min-width: 0;
  }

  &__type {
    text-transform: capitalize;
    margin-right: 0.5rem;
  }
}
</style>
